var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 24h24"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shuffle-solid",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.238 2.15c0.75-0.313 1.606-0.138 2.181 0.431l4 4c0.375 0.375 0.588 0.881 0.588 1.413s-0.212 1.037-0.587 1.412l-4 4c-0.575 0.575-1.431 0.744-2.181 0.431s-1.238-1.037-1.238-1.85v-1.988h-2c-0.631 0-1.225 0.294-1.6 0.8l-2.65 3.531-2.5-3.331 1.95-2.6c1.131-1.513 2.913-2.4 4.8-2.4h2v-2c0-0.806 0.488-1.538 1.238-1.85zM10.25 17.669l2.5 3.331-1.95 2.6c-1.131 1.512-2.912 2.4-4.8 2.4h-4c-1.106 0-2-0.894-2-2s0.894-2 2-2h4c0.631 0 1.225-0.294 1.6-0.8l2.65-3.531zM27.413 29.419c-0.575 0.575-1.431 0.744-2.181 0.431s-1.238-1.038-1.238-1.85v-2h-1.994c-1.887 0-3.669-0.887-4.8-2.4l-9.6-12.8c-0.375-0.506-0.969-0.8-1.6-0.8h-4c-1.106 0-2-0.894-2-2s0.894-2 2-2h4c1.888 0 3.669 0.888 4.8 2.4l9.6 12.8c0.375 0.506 0.969 0.8 1.6 0.8h2v-2c0-0.806 0.488-1.538 1.238-1.85s1.606-0.137 2.181 0.431l4 4c0.375 0.375 0.588 0.881 0.588 1.413s-0.212 1.038-0.587 1.413l-4 4z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart-icon",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.123 5.121c2.386-2.488 4.058-4.639 7.734-5.059 6.903-0.792 13.252 6.274 9.766 13.231-0.992 1.981-3.012 4.338-5.246 6.65-2.452 2.538-5.166 5.026-7.067 6.912l-5.184 5.142-4.284-4.123c-5.154-4.963-13.559-11.211-13.836-18.951-0.194-5.422 4.085-8.896 9.006-8.833 4.397 0.060 6.247 2.246 9.11 5.032z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-rotate-solid",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.931 8.931c3.888-3.888 10.169-3.906 14.081-0.063l-2.575 2.569c-0.431 0.431-0.556 1.075-0.325 1.637s0.781 0.925 1.387 0.925h7.469c0 0 0 0 0 0h0.531c0.831 0 1.5-0.669 1.5-1.5v-8c0-0.606-0.363-1.156-0.925-1.388s-1.206-0.106-1.637 0.325l-2.6 2.6c-5.475-5.406-14.294-5.388-19.738 0.063-1.525 1.525-2.625 3.319-3.3 5.237-0.369 1.044 0.181 2.181 1.219 2.55s2.181-0.181 2.55-1.219c0.481-1.363 1.263-2.644 2.363-3.738zM1 19.5v8c0 0.606 0.363 1.156 0.925 1.387s1.206 0.106 1.637-0.325l2.6-2.6c5.475 5.406 14.294 5.387 19.737-0.063 1.525-1.525 2.631-3.319 3.306-5.231 0.369-1.044-0.181-2.181-1.219-2.55s-2.181 0.181-2.55 1.219c-0.481 1.363-1.262 2.644-2.363 3.738-3.887 3.887-10.169 3.906-14.081 0.063l2.569-2.575c0.431-0.431 0.556-1.075 0.325-1.637s-0.781-0.925-1.387-0.925h-8c-0.831 0-1.5 0.669-1.5 1.5z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter-solid",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.517 31.788c-0.388 0-0.702-0.315-0.702-0.703v0-11.551c0-0.388 0.315-0.703 0.702-0.703s0.702 0.315 0.702 0.703v0 11.551c0 0.388-0.315 0.703-0.702 0.703v0zM26.448 21.025c-0.388 0-0.703-0.315-0.703-0.703v0-19.444c0-0.388 0.315-0.703 0.703-0.703s0.703 0.315 0.703 0.703v0 19.444c0 0.388-0.315 0.703-0.703 0.703v0zM15.982 31.788c-0.388 0-0.703-0.315-0.703-0.703v0-21.102c0-0.388 0.315-0.703 0.703-0.703s0.703 0.315 0.703 0.703v0 21.102c0 0.388-0.315 0.703-0.703 0.703v0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.982 10.686c-1.919 0-3.481-1.561-3.481-3.481s1.561-3.481 3.481-3.481 3.481 1.561 3.481 3.481-1.561 3.481-3.481 3.481zM15.982 5.13c-1.145 0-2.076 0.931-2.076 2.076s0.931 2.076 2.076 2.076 2.076-0.931 2.076-2.076-0.931-2.076-2.076-2.076zM5.517 20.238c-1.919 0-3.481-1.561-3.481-3.481s1.561-3.481 3.481-3.481 3.481 1.561 3.481 3.481-1.562 3.481-3.481 3.481zM5.517 14.681c-1.145 0-2.076 0.931-2.076 2.076s0.931 2.076 2.076 2.076 2.076-0.931 2.076-2.076-0.931-2.076-2.076-2.076zM26.448 26.582c-1.919 0-3.481-1.561-3.481-3.481s1.561-3.481 3.481-3.481c1.92 0 3.481 1.561 3.481 3.481s-1.561 3.481-3.481 3.481zM26.448 21.025c-1.145 0-2.076 0.931-2.076 2.076s0.931 2.076 2.076 2.076 2.076-0.931 2.076-2.076-0.931-2.076-2.076-2.076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.517 14.681c-0.388 0-0.702-0.315-0.702-0.703v0-13.1c0-0.388 0.315-0.703 0.702-0.703s0.702 0.315 0.702 0.703v0 13.1c0 0.388-0.315 0.703-0.702 0.703v0zM15.982 5.13c-0.388 0-0.703-0.315-0.703-0.702v0-3.549c0-0.388 0.315-0.703 0.703-0.703s0.703 0.315 0.703 0.703v0 3.549c0 0.388-0.315 0.702-0.703 0.702v0zM26.448 31.788c-0.388 0-0.703-0.315-0.703-0.703v0-5.207c0-0.388 0.315-0.703 0.703-0.703s0.703 0.315 0.703 0.703v0 5.207c0 0.388-0.315 0.703-0.703 0.703v0z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search-Icon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.667 20h-1.053l-0.373-0.36c1.301-1.502 2.093-3.475 2.093-5.634 0-0.002 0-0.004 0-0.006v0c0-4.786-3.88-8.667-8.667-8.667s-8.667 3.88-8.667 8.667c0 4.786 3.88 8.667 8.667 8.667v0c2.147 0 4.12-0.787 5.64-2.093l0.36 0.373v1.053l6.667 6.653 1.987-1.987-6.653-6.667zM12.667 20c-3.32 0-6-2.68-6-6s2.68-6 6-6 6 2.68 6 6-2.68 6-6 6z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sun",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.324 16c0 3.681 2.995 6.676 6.676 6.676s6.676-2.995 6.676-6.676c0-3.681-2.995-6.676-6.676-6.676s-6.676 2.995-6.676 6.676zM16 11.991c2.211 0 4.009 1.799 4.009 4.009s-1.799 4.009-4.009 4.009c-2.211 0-4.009-1.799-4.009-4.009s1.799-4.009 4.009-4.009zM14.664 25.333h2.667v4h-2.667v-4zM14.664 2.667h2.667v4h-2.667v-4zM2.664 14.667h4v2.667h-4v-2.667zM25.331 14.667h4v2.667h-4v-2.667zM5.625 24.484l2.827-2.829 1.887 1.885-2.827 2.829-1.887-1.885zM21.653 8.459l2.829-2.829 1.885 1.885-2.829 2.829-1.885-1.885zM8.456 10.345l-2.829-2.829 1.887-1.885 2.827 2.829-1.884 1.885zM26.368 24.485l-1.885 1.885-2.829-2.829 1.885-1.885 2.829 2.829z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-moon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.222 18.244c-1.071 0.284-2.174 0.428-3.282 0.428-3.374 0-6.542-1.312-8.922-3.691-1.563-1.572-2.686-3.526-3.259-5.667s-0.573-4.395-0.003-6.537c0.071-0.268 0.071-0.55-0.001-0.817s-0.213-0.512-0.409-0.707c-0.196-0.196-0.44-0.337-0.708-0.408s-0.55-0.072-0.817 0c-2.681 0.715-5.128 2.122-7.094 4.080-6.16 6.16-6.16 16.186 0 22.349 1.464 1.472 3.206 2.64 5.124 3.434s3.975 1.201 6.052 1.196c2.076 0.006 4.132-0.4 6.050-1.195s3.659-1.962 5.122-3.434c1.96-1.966 3.368-4.414 4.082-7.097 0.071-0.268 0.070-0.549-0.002-0.817s-0.213-0.511-0.409-0.707c-0.196-0.196-0.44-0.337-0.707-0.409s-0.549-0.073-0.817-0.002zM24.841 25.041c-1.171 1.177-2.564 2.111-4.098 2.746s-3.179 0.96-4.84 0.956c-1.661 0.004-3.307-0.321-4.841-0.957s-2.928-1.57-4.1-2.747c-4.927-4.929-4.927-12.95 0-17.879 0.952-0.951 2.051-1.742 3.255-2.344-0.176 2.274 0.141 4.559 0.929 6.7s2.029 4.085 3.638 5.702c1.613 1.614 3.558 2.858 5.699 3.647s4.428 1.103 6.703 0.921c-0.604 1.202-1.396 2.3-2.345 3.254z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 24h24"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.733 10.304 22.229 8.8l-5.963 5.963L10.303 8.8l-1.504 1.504 5.963 5.963-5.963 5.963 1.504 1.504 5.963-5.963 5.963 5.963 1.504-1.504-5.963-5.963 5.963-5.963z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right-small",
    viewBox: "0 0 19 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 4.8,
    d: "M3.2 28.8l12.8-12.8-12.8-12.8"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left-small",
    viewBox: "0 0 19 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 4.8,
    d: "M16 28.8l-12.8-12.8 12.8-12.8"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icons8-summer-smith",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f69272",
    style: {
      fill: "var(--color1, #f69272)"
    },
    d: "M13.12 4.8c0 0-7.68-2.24-8.32 5.76-0.435 5.432 4.48 6.4 0.32 15.68 0 0 6.080-0.64 7.040-7.68s0.96-13.76 0.96-13.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M5.12 26.56c-0.102 0-0.198-0.049-0.259-0.132-0.067-0.093-0.080-0.214-0.033-0.319 2.585-5.767 1.594-8.245 0.636-10.642-0.565-1.413-1.148-2.874-0.984-4.932 0.197-2.464 1.068-4.245 2.587-5.292 2.561-1.765 5.997-0.791 6.142-0.749 0.137 0.040 0.231 0.165 0.231 0.308 0 0.067-0.011 6.822-0.963 13.803-0.983 7.205-7.26 7.948-7.324 7.955-0.011 0.001-0.022 0.002-0.033 0.002zM10.832 4.835c-1.063 0-2.336 0.199-3.404 0.937-1.351 0.933-2.128 2.553-2.309 4.814-0.153 1.909 0.378 3.238 0.94 4.644 0.976 2.442 1.984 4.965-0.406 10.589 1.494-0.348 5.437-1.78 6.19-7.302 0.843-6.181 0.944-12.185 0.956-13.467-0.356-0.080-1.090-0.215-1.966-0.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f69272",
    style: {
      fill: "var(--color1, #f69272)"
    },
    d: "M24.32 9.92c0 0 2.24-7.36-7.36-7.040-10.239 0.341-9.92 12.48-6.080 16.32 4.209 4.209 13.44-9.28 13.44-9.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M12.823 20.334c-0.837 0-1.566-0.304-2.169-0.908-2.202-2.202-3.455-7.356-1.811-11.52 1.31-3.317 4.189-5.215 8.107-5.346 3.306-0.11 5.628 0.666 6.886 2.306 1.669 2.175 0.828 5.027 0.791 5.147-0.010 0.031-0.024 0.061-0.042 0.088-0.273 0.399-6.745 9.782-11.424 10.217-0.115 0.011-0.227 0.016-0.338 0.016zM17.561 3.19c-0.193 0-0.389 0.003-0.59 0.010-4.675 0.156-6.676 2.773-7.532 4.941-1.552 3.93-0.39 8.774 1.668 10.833 0.549 0.549 1.203 0.78 1.994 0.707 4.23-0.393 10.441-9.202 10.926-9.899 0.095-0.357 0.662-2.757-0.702-4.531-1.053-1.369-2.99-2.061-5.764-2.061zM24.32 9.92v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed5b3",
    style: {
      fill: "var(--color3, #fed5b3)"
    },
    d: "M24.96 8.96c-1.6-4.8-11.2-4.8-12.8 2.24 0 0-0.64 2.56-0.403 6.201-0.882 0.301-1.517 1.135-1.517 2.119 0 1.237 1.003 2.24 2.24 2.24 0.079 0 0.158-0.004 0.235-0.012 0.461 1.671 1.018 3.172 1.685 4.172 2.56 3.84 8.96 3.2 10.56-0.96 1.532-3.985 1.92-10.24 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M19.396 28.791c-2.16 0-4.128-0.992-5.262-2.693-0.596-0.894-1.153-2.244-1.658-4.018-1.41-0.003-2.556-1.15-2.556-2.56 0-1.012 0.595-1.919 1.504-2.331-0.197-3.524 0.399-5.963 0.426-6.067 0.93-4.091 4.406-5.7 7.101-5.832 3.012-0.15 5.552 1.286 6.313 3.569 2.136 6.407 1.332 12.74-0.005 16.216-0.771 2.003-2.715 3.41-5.074 3.672-0.265 0.029-0.529 0.044-0.789 0.044zM12.715 21.428c0.142 0 0.27 0.095 0.308 0.235 0.505 1.829 1.058 3.202 1.643 4.080 1.138 1.707 3.227 2.615 5.448 2.368 2.12-0.235 3.862-1.486 4.547-3.266 1.299-3.378 2.077-9.538-0.005-15.784-0.669-2.007-2.947-3.268-5.675-3.132-2.589 0.127-5.659 1.597-6.51 5.341-0.008 0.032-0.627 2.567-0.395 6.109 0.009 0.144-0.079 0.277-0.216 0.324-0.778 0.265-1.301 0.996-1.301 1.816 0 1.059 0.861 1.92 1.92 1.92 0.068 0 0.135-0.004 0.201-0.011 0.011-0.001 0.022-0.002 0.034-0.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M22.080 19.68h-2.56c-0.088 0-0.16-0.072-0.16-0.16s0.072-0.16 0.16-0.16h2.32l-1.508-3.619c-0.034-0.082 0.005-0.175 0.086-0.209s0.175 0.004 0.209 0.086l1.6 3.84c0.020 0.049 0.015 0.106-0.015 0.15s-0.080 0.071-0.133 0.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M20.339 24.55c-0.003 0-0.006 0-0.009 0-1.57-0.005-2.644-1.193-2.689-1.244-0.059-0.066-0.052-0.167 0.013-0.226s0.167-0.053 0.226 0.013c0.010 0.012 1.029 1.134 2.454 1.137 0.002 0 0.004 0 0.006 0 0.949 0 1.872-0.49 2.742-1.458 0.060-0.065 0.161-0.071 0.226-0.012s0.071 0.16 0.012 0.226c-0.934 1.037-1.937 1.563-2.98 1.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M14.24 9.6c-0.041 0-0.082-0.016-0.113-0.047-0.062-0.062-0.062-0.163 0-0.226 0.027-0.027 0.689-0.674 2.622-1.319 0.084-0.027 0.174 0.017 0.203 0.101s-0.018 0.174-0.101 0.202c-1.849 0.616-2.492 1.236-2.498 1.242-0.031 0.031-0.072 0.046-0.113 0.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M25.28 9.92c-0.041 0-0.082-0.016-0.113-0.047-1.194-1.195-1.804-1.233-1.81-1.233-0.087-0.004-0.156-0.076-0.155-0.163s0.071-0.157 0.158-0.157c0.072 0 0.743 0.037 2.033 1.327 0.062 0.062 0.062 0.164 0 0.226-0.031 0.031-0.072 0.047-0.113 0.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M19.040 13.44c0 1.502-1.218 2.72-2.72 2.72s-2.72-1.218-2.72-2.72c0-1.502 1.218-2.72 2.72-2.72s2.72 1.218 2.72 2.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M16.32 16.32c-1.588 0-2.88-1.292-2.88-2.88s1.292-2.88 2.88-2.88 2.88 1.292 2.88 2.88-1.292 2.88-2.88 2.88zM16.32 10.88c-1.412 0-2.56 1.148-2.56 2.56s1.148 2.56 2.56 2.56 2.56-1.148 2.56-2.56-1.148-2.56-2.56-2.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M26.080 13.44c0 1.502-1.218 2.72-2.72 2.72s-2.72-1.218-2.72-2.72c0-1.502 1.218-2.72 2.72-2.72s2.72 1.218 2.72 2.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M23.36 16.32c-1.588 0-2.88-1.292-2.88-2.88s1.292-2.88 2.88-2.88 2.88 1.292 2.88 2.88-1.292 2.88-2.88 2.88zM23.36 10.88c-1.412 0-2.56 1.148-2.56 2.56s1.148 2.56 2.56 2.56 2.56-1.148 2.56-2.56-1.148-2.56-2.56-2.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M17.28 13.6c0 0.265-0.215 0.48-0.48 0.48s-0.48-0.215-0.48-0.48c0-0.265 0.215-0.48 0.48-0.48s0.48 0.215 0.48 0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M24 13.6c0 0.265-0.215 0.48-0.48 0.48s-0.48-0.215-0.48-0.48c0-0.265 0.215-0.48 0.48-0.48s0.48 0.215 0.48 0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M7.254 24.296c-0.025 0-0.050-0.006-0.074-0.018-0.078-0.041-0.109-0.137-0.068-0.216 0.528-1.016 0.85-2.14 0.955-3.342 0.007-0.088 0.086-0.15 0.173-0.145 0.088 0.008 0.153 0.085 0.145 0.173-0.109 1.244-0.443 2.408-0.99 3.461-0.028 0.055-0.084 0.086-0.142 0.086z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M8.258 19.61c-0.086 0-0.156-0.068-0.16-0.153-0.034-0.852-0.17-1.404-0.171-1.409-0.021-0.086 0.031-0.172 0.116-0.194s0.172 0.031 0.194 0.116c0.006 0.023 0.145 0.587 0.18 1.474 0.004 0.088-0.065 0.163-0.153 0.167-0.002-0-0.004-0-0.006-0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icons8-rick-sanchez",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a3a3cd",
    style: {
      fill: "var(--color1, #a3a3cd)"
    },
    d: "M9.621 25.686l-4.766 0.596 1.788-3.277-4.171-1.192 3.575-2.681-4.171-4.171 4.171-1.191-4.766-6.554 6.852 1.192-1.49-7.448 7.15 4.766 4.766-4.766 0.596 6.256 7.745-1.788-2.979 6.852 5.362 2.383-5.064 2.681 3.873 2.681-3.277 1.489 1.787 3.575-3.873 0.298 0.298 2.085-8.043-2.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M23.027 27.793c-0.027 0-0.054-0.004-0.080-0.010l-7.995-2.073-5.301 0.294-4.756 0.595c-0.118 0.014-0.236-0.038-0.304-0.138s-0.074-0.228-0.017-0.333l1.596-2.926-3.786-1.082c-0.117-0.033-0.205-0.13-0.227-0.25s0.026-0.241 0.123-0.314l3.28-2.46-3.91-3.909c-0.080-0.080-0.112-0.197-0.084-0.307s0.113-0.196 0.222-0.227l3.73-1.066-4.497-6.184c-0.076-0.106-0.082-0.247-0.013-0.357s0.199-0.169 0.326-0.146l6.392 1.112-1.398-6.989c-0.025-0.127 0.028-0.257 0.136-0.329s0.248-0.072 0.356-0l6.932 4.621 4.581-4.581c0.087-0.088 0.217-0.117 0.335-0.075s0.198 0.147 0.21 0.271l0.561 5.892 7.39-1.705c0.117-0.028 0.241 0.014 0.318 0.107s0.096 0.221 0.047 0.332l-2.852 6.561 5.072 2.254c0.112 0.050 0.186 0.159 0.19 0.281s-0.061 0.236-0.17 0.294l-4.599 2.435 3.44 2.381c0.095 0.066 0.147 0.177 0.137 0.292s-0.082 0.215-0.186 0.263l-2.975 1.352 1.639 3.278c0.047 0.095 0.045 0.208-0.008 0.3s-0.148 0.153-0.254 0.162l-3.532 0.272 0.25 1.747c0.015 0.106-0.024 0.212-0.104 0.284-0.060 0.053-0.136 0.082-0.213 0.082zM14.983 25.068c0.027 0 0.054 0.004 0.080 0.010l7.579 1.965-0.23-1.61c-0.012-0.088 0.012-0.177 0.067-0.246s0.137-0.112 0.225-0.119l3.398-0.261-1.575-3.149c-0.039-0.078-0.044-0.168-0.015-0.25s0.090-0.148 0.169-0.184l2.764-1.256-3.409-2.36c-0.092-0.064-0.144-0.171-0.137-0.282s0.071-0.212 0.17-0.264l4.483-2.373-4.761-2.116c-0.161-0.071-0.233-0.259-0.164-0.42l2.726-6.269-7.127 1.645c-0.090 0.020-0.184 0.002-0.259-0.052s-0.123-0.137-0.131-0.229l-0.531-5.58-4.286 4.286c-0.108 0.108-0.277 0.125-0.404 0.040l-6.507-4.338 1.338 6.69c0.020 0.104-0.011 0.211-0.085 0.286s-0.18 0.11-0.284 0.092l-6.074-1.056 4.302 5.915c0.061 0.084 0.078 0.194 0.044 0.292s-0.114 0.175-0.215 0.204l-3.648 1.042 3.786 3.786c0.066 0.066 0.1 0.156 0.093 0.249s-0.053 0.178-0.127 0.233l-3.060 2.294 3.551 1.014c0.093 0.027 0.17 0.095 0.207 0.184s0.032 0.192-0.014 0.277l-1.488 2.729 4.147-0.518c0.007-0.001 0.015-0.002 0.022-0.002l5.362-0.298c0.006 0 0.012-0 0.018-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed5b3",
    style: {
      fill: "var(--color3, #fed5b3)"
    },
    d: "M10.56 20.48c0 1.060-0.86 1.92-1.92 1.92s-1.92-0.86-1.92-1.92c0-1.060 0.86-1.92 1.92-1.92s1.92 0.86 1.92 1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M8.64 22.72c-1.235 0-2.24-1.005-2.24-2.24s1.005-2.24 2.24-2.24 2.24 1.005 2.24 2.24-1.005 2.24-2.24 2.24zM8.64 18.88c-0.882 0-1.6 0.718-1.6 1.6s0.718 1.6 1.6 1.6 1.6-0.718 1.6-1.6-0.718-1.6-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed5b3",
    style: {
      fill: "var(--color3, #fed5b3)"
    },
    d: "M23.68 20.48c0 1.060-0.86 1.92-1.92 1.92s-1.92-0.86-1.92-1.92c0-1.060 0.86-1.92 1.92-1.92s1.92 0.86 1.92 1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M21.76 22.72c-1.235 0-2.24-1.005-2.24-2.24s1.005-2.24 2.24-2.24 2.24 1.005 2.24 2.24-1.005 2.24-2.24 2.24zM21.76 18.88c-0.882 0-1.6 0.718-1.6 1.6s0.718 1.6 1.6 1.6 1.6-0.718 1.6-1.6-0.718-1.6-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed5b3",
    style: {
      fill: "var(--color3, #fed5b3)"
    },
    d: "M8.616 13.326c0 0-1.186 9.316 1.186 13.523s9.191 4.508 10.97-0.3 1.385-10.14 0.889-13.824c-0.889-6.611-12.452-8.715-13.045 0.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M15.508 30.4c-2.458 0-4.814-1.318-5.984-3.393-2.379-4.219-1.29-13.2-1.226-13.71 0.303-4.699 3.322-6.476 6.047-6.572 3.267-0.116 7.118 2.131 7.633 5.958 0.488 3.628 0.926 9.025-0.907 13.977-0.792 2.141-2.669 3.531-5.021 3.718-0.181 0.015-0.362 0.021-0.542 0.021zM14.589 7.36c-0.074 0-0.148 0.001-0.222 0.004-3.17 0.111-5.2 2.348-5.432 5.983-0 0.007-0.001 0.013-0.002 0.020-0.012 0.092-1.145 9.26 1.147 13.325 1.136 2.015 3.512 3.238 5.918 3.048 2.128-0.17 3.759-1.373 4.473-3.302 1.782-4.818 1.351-10.109 0.872-13.67-0.456-3.387-3.814-5.408-6.755-5.408zM8.617 13.326v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M10.13 14.88c-0.324 0.524-0.462 1.176-0.306 1.866 0.212 0.941 0.985 1.689 1.933 1.868 1.581 0.298 2.963-0.907 2.963-2.435 0-0.477-0.137-0.921-0.37-1.299h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M12.235 18.818c-0.168 0-0.338-0.016-0.507-0.047-1.007-0.19-1.834-0.989-2.060-1.989-0.155-0.688-0.039-1.393 0.326-1.985 0.029-0.047 0.081-0.076 0.136-0.076h4.22c0.056 0 0.107 0.029 0.136 0.076 0.258 0.418 0.394 0.896 0.394 1.383 0 0.788-0.348 1.53-0.956 2.033-0.477 0.396-1.074 0.606-1.69 0.606zM10.221 15.040c-0.286 0.504-0.372 1.094-0.242 1.671 0.198 0.878 0.924 1.579 1.807 1.746 0.693 0.131 1.399-0.048 1.932-0.49s0.84-1.094 0.84-1.787c0-0.398-0.104-0.79-0.301-1.139h-4.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed5b3",
    style: {
      fill: "var(--color3, #fed5b3)"
    },
    d: "M10.952 13.871c-0.689 0.421-1.156 1.169-1.187 2.028 1.656-0.435 3.302-0.501 4.939-0.189-0.081-0.721-0.471-1.349-1.035-1.747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M9.765 16.059c-0.036 0-0.071-0.012-0.1-0.035-0.039-0.032-0.061-0.080-0.060-0.131 0.032-0.888 0.504-1.695 1.263-2.159 0.075-0.046 0.173-0.022 0.22 0.053s0.022 0.174-0.053 0.22c-0.605 0.37-1.003 0.988-1.092 1.682 1.528-0.372 3.062-0.431 4.567-0.177-0.119-0.57-0.452-1.079-0.933-1.419-0.072-0.051-0.089-0.151-0.038-0.223s0.152-0.089 0.223-0.038c0.616 0.435 1.018 1.113 1.101 1.86 0.006 0.051-0.013 0.1-0.050 0.135s-0.089 0.049-0.139 0.040c-1.6-0.305-3.237-0.242-4.868 0.187-0.013 0.004-0.027 0.005-0.040 0.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M16.21 14.88c-0.324 0.524-0.462 1.176-0.306 1.866 0.212 0.941 0.985 1.689 1.933 1.868 1.581 0.298 2.963-0.907 2.963-2.435 0-0.477-0.137-0.921-0.37-1.299h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M18.315 18.818c-0.168 0-0.338-0.016-0.507-0.047-1.007-0.19-1.834-0.989-2.060-1.989-0.155-0.688-0.039-1.393 0.326-1.985 0.029-0.047 0.081-0.076 0.136-0.076h4.22c0.056 0 0.107 0.029 0.136 0.076 0.258 0.418 0.394 0.896 0.394 1.383 0 0.788-0.348 1.53-0.956 2.033-0.477 0.396-1.074 0.606-1.69 0.606zM16.301 15.040c-0.286 0.504-0.372 1.094-0.242 1.671 0.198 0.878 0.924 1.579 1.807 1.746 0.694 0.131 1.399-0.048 1.932-0.49s0.84-1.094 0.84-1.787c0-0.398-0.104-0.79-0.301-1.139h-4.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed5b3",
    style: {
      fill: "var(--color3, #fed5b3)"
    },
    d: "M17.032 13.871c-0.689 0.421-1.156 1.169-1.187 2.028 1.656-0.435 3.302-0.501 4.939-0.189-0.081-0.721-0.471-1.349-1.035-1.747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M15.845 16.059c-0.036 0-0.071-0.012-0.1-0.035-0.039-0.032-0.061-0.080-0.060-0.131 0.032-0.888 0.504-1.695 1.263-2.159 0.075-0.046 0.173-0.022 0.22 0.053s0.022 0.174-0.053 0.22c-0.605 0.37-1.003 0.988-1.092 1.682 1.528-0.372 3.062-0.431 4.567-0.177-0.119-0.57-0.452-1.079-0.933-1.419-0.072-0.051-0.089-0.151-0.038-0.223s0.152-0.089 0.223-0.038c0.616 0.435 1.018 1.113 1.101 1.86 0.006 0.051-0.013 0.1-0.050 0.135s-0.089 0.049-0.139 0.040c-1.6-0.305-3.237-0.242-4.868 0.187-0.013 0.004-0.027 0.005-0.040 0.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M12.8 15.84c0 0.265-0.215 0.48-0.48 0.48s-0.48-0.215-0.48-0.48c0-0.265 0.215-0.48 0.48-0.48s0.48 0.215 0.48 0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M18.88 15.84c0 0.265-0.215 0.48-0.48 0.48s-0.48-0.215-0.48-0.48c0-0.265 0.215-0.48 0.48-0.48s0.48 0.215 0.48 0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M11.915 20.048c-1.080 0-1.795-0.63-1.833-0.665-0.066-0.059-0.071-0.16-0.012-0.226s0.16-0.070 0.226-0.012c0.045 0.040 1.12 0.98 2.605 0.386 0.082-0.033 0.175 0.007 0.208 0.089s-0.007 0.175-0.089 0.208c-0.397 0.159-0.768 0.22-1.104 0.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M18.274 20.048c-0.336 0-0.707-0.061-1.104-0.22-0.082-0.033-0.122-0.126-0.089-0.208s0.126-0.122 0.208-0.089c1.49 0.596 2.593-0.376 2.604-0.386 0.066-0.060 0.167-0.054 0.226 0.012s0.054 0.167-0.012 0.226c-0.039 0.035-0.754 0.665-1.834 0.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M16.021 9.84c-0.077 0-0.145-0.056-0.158-0.135-0.014-0.087 0.046-0.169 0.133-0.183 0.382-0.061 0.746-0.141 1.080-0.236 0.086-0.024 0.174 0.025 0.198 0.11s-0.025 0.173-0.11 0.198c-0.346 0.099-0.722 0.181-1.117 0.244-0.008 0.002-0.017 0.002-0.026 0.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M13.873 10c-0.906 0-1.537-0.077-1.573-0.082-0.087-0.011-0.15-0.091-0.139-0.179s0.095-0.15 0.179-0.139c0.012 0.002 1.215 0.148 2.666 0.037 0.080-0.008 0.165 0.059 0.172 0.147s-0.059 0.165-0.147 0.172c-0.414 0.032-0.806 0.043-1.157 0.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M15.040 22.32c-0.258 0-0.504-0.133-0.678-0.364-0.184-0.246-0.282-0.59-0.282-0.996v-1.92c0-0.088 0.072-0.16 0.16-0.16s0.16 0.072 0.16 0.16v1.92c0 0.715 0.332 1.040 0.64 1.040s0.64-0.325 0.64-1.040v-1.92c0-0.088 0.072-0.16 0.16-0.16s0.16 0.072 0.16 0.16v1.92c0 0.934-0.498 1.36-0.96 1.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M18.72 25.6c-0.020 0-0.042-0.004-0.061-0.012-3.728-1.554-7.198-0.018-7.232-0.002-0.080 0.036-0.175 0.001-0.212-0.079s-0.001-0.175 0.079-0.212c0.036-0.017 3.628-1.609 7.488-0.002 0.082 0.034 0.12 0.128 0.086 0.209-0.026 0.062-0.085 0.099-0.148 0.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M7.013 12.817c-0.048 0-0.096-0.021-0.127-0.063l-0.656-0.856c-0.054-0.070-0.041-0.171 0.030-0.224s0.171-0.040 0.224 0.030l0.656 0.856c0.054 0.070 0.041 0.171-0.030 0.224-0.029 0.022-0.063 0.033-0.097 0.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M5.713 11.12c-0.048 0-0.096-0.021-0.127-0.063l-1.642-2.143c-0.054-0.070-0.041-0.171 0.030-0.224s0.171-0.040 0.224 0.030l1.642 2.143c0.054 0.070 0.041 0.171-0.030 0.224-0.029 0.022-0.063 0.033-0.097 0.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M9.341 7.833c-0.073 0-0.139-0.050-0.156-0.124l-0.512-2.226c-0.020-0.086 0.034-0.172 0.12-0.192 0.088-0.020 0.172 0.034 0.192 0.12l0.512 2.226c0.020 0.086-0.034 0.172-0.12 0.192-0.012 0.003-0.024 0.004-0.036 0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M8.604 4.627c-0.073 0-0.139-0.050-0.156-0.124l-0.202-0.879c-0.020-0.086 0.034-0.172 0.12-0.192 0.087-0.020 0.172 0.034 0.192 0.12l0.202 0.879c0.020 0.086-0.034 0.172-0.12 0.192-0.012 0.003-0.024 0.004-0.036 0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3a3cd",
    style: {
      fill: "var(--color1, #a3a3cd)"
    },
    d: "M13.036 12.982c-0.812 0-1.673-0.051-2.573-0.189-0.349-0.054-0.589-0.38-0.535-0.73s0.383-0.59 0.73-0.535c2.116 0.325 3.969 0.131 5.604-0.041 1.494-0.157 2.784-0.293 3.796 0.071 0.333 0.12 0.506 0.486 0.386 0.819s-0.486 0.505-0.819 0.386c-0.737-0.265-1.892-0.143-3.23-0.003-0.984 0.103-2.114 0.221-3.358 0.221z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M13.036 13.142c-0.913 0-1.762-0.062-2.597-0.191-0.436-0.067-0.736-0.476-0.669-0.912 0.033-0.212 0.147-0.398 0.32-0.525 0.172-0.126 0.382-0.179 0.593-0.144 2.095 0.322 3.937 0.129 5.562-0.042 1.514-0.159 2.821-0.296 3.866 0.079 0.201 0.072 0.362 0.219 0.453 0.412s0.101 0.411 0.029 0.612c-0.149 0.415-0.607 0.631-1.023 0.483-0.703-0.253-1.841-0.133-3.159 0.006-0.998 0.105-2.125 0.223-3.375 0.223zM10.558 11.68c-0.1 0-0.197 0.032-0.28 0.092-0.104 0.076-0.173 0.188-0.193 0.315-0.040 0.261 0.14 0.507 0.402 0.547 0.819 0.126 1.652 0.187 2.549 0.187 1.233 0 2.351-0.117 3.337-0.221 1.361-0.143 2.532-0.267 3.305 0.011 0.249 0.089 0.524-0.041 0.614-0.29 0.044-0.121 0.037-0.251-0.018-0.367s-0.151-0.204-0.272-0.247c-0.977-0.351-2.251-0.218-3.724-0.062-1.645 0.173-3.508 0.368-5.645 0.040-0.025-0.004-0.050-0.006-0.074-0.006z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.1642074c75f4ca2c70d97cd8eff41f46.svg";
export { ForwardRef as ReactComponent };